
import {staticPath} from '@/utils/baseUrl.js'
let talent_lable = ''
if(staticPath == '/') {
	talent_lable = '抖音'
} else if(staticPath == '/ks/') {
	talent_lable = '快手'
} else if(staticPath == '/wx/') {
	talent_lable = '微信'
} else {
	talent_lable = ''
}
export const data = {
	data() {
		return {
			headerList: [
				{
					prop: 'product_title',
					label: '课程标题',
					// width: 220
				},
				{
					prop: 'pay_amount',
					label: '支付金额',
					align: 'center',
					width: 150
				},
				{
					prop: 'status',
					label: '状态',
					width: 100
				},
				{
					prop: 'talent_name',
					label: '推广人'+talent_lable+'昵称',
					width: 150,
					excludeList: ['/wx/']
				},
				{
					prop: 'nick_nake',
					label: '购买人',
					width: 140
				},
				{
					prop: 'address',
					label: '收货信息',
					width: 130
				}
			]
		}
	}
}
